import { _ } from '@zto/zpage'

import { commonOptions } from '@/config'
import { getCommonOptionLabel } from '@/utils'

export interface DeviceRealtimeStatusCard {
  label: string
  value: string
  theme: 'power' | 'network'
}

export function normalizeRealtimeStatusCards(response: any, fallback: DeviceRealtimeStatusCard[] = []) {
  const detail = response?.result || response || {}

  if (!Object.keys(detail).length) return fallback

  const power = detail?.power
  const onlineStatusName = getCommonOptionLabel(commonOptions.tdlOnlineStatus, detail?.onlineStatus)

  return [
    {
      label: '电量',
      content: _.isNumber(power) ? `${power}%` : '--',
      value: power > 20 ? 'ON' : 'OFF',
      theme: 'power'
    },
    {
      label: '网络',
      content: onlineStatusName || '',
      value: detail?.onlineStatus,
      theme: 'network'
    },
    {
      label: '是否在基站',
      content: detail?.runInBase ? '是' : '否',
      value: detail?.runInBase,
      theme: 'runInBase'
    }
  ]
}
